module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div class=\"prop-header\"><span class=\"prop-label\">Header</span></div>\r\n<div class=\"row prop-detail\">\r\n     <div class=\"col-md-3 prop-sublabel hide\">Color</div>\r\n     <div class=\"col-md-9\">\r\n          <input id=\"titleBackgroundColorPicker\" name=\"titleBackgroundColorPicker\" type=\"color\" value=\"")
    ; __append(escapeFn( titleBackgroundColor ))
    ; __append("\" style=\"width: 20px; border: 1px solid #aaaaaa; padding: 0px; height: 23px;\" />\r\n          <input id=\"titleBackgroundColor\" name=\"titleBackgroundColor\" type=\"text\" maxlength=\"7\" class=\"color-picker-text\" value=\"")
    ; __append(escapeFn( titleBackgroundColor ))
    ; __append("\" />\r\n     </div>\r\n</div>")
  }
  return __output;

}